import React from 'react';
import './ServicesSection.css';
import ServicesList from './ServicesList';
import ConstructionNotice from './ConstructionNotice';

const ServicesSection = () => {
  return (
    <div className="services-section">
      <ServicesList />
      <ConstructionNotice />
    </div>
  );
};

export default ServicesSection;

